<template>
  <k-dialog 
    transition="dialog-bottom-transition" 
    no-click-animation 
    v-on:resize="onResize" 
    :persistent="persistent" 
    scrollable 
    v-model="visible" 
    :max-width="inset ? '70%' : '100%'" 
    :fullscreen="fullscreen"
  >
    <div class="ks-floating-menu ks-bottom-sheet" :class="BottomSheetClasses">
      <template v-if="this.router">
        <router-view name="bottomEditor" :key="editorKey" :prependExtraTabs="prependExtraTabs" :appendExtraTabs="appendExtraTabs" :defaultTab="defaultTab"></router-view>
      </template>
      <template v-else>
        <slot></slot>
      </template>
    </div>
  </k-dialog>
</template>

<script>
export default {
  props: {
    persistent: {
      type: Boolean,
      default: true
    },
    router: {
      type: Boolean,
      default: true
    },
    value: Boolean,
    prependExtraTabs: {
      type: Array,
      default: () => []
    },
    appendExtraTabs: {
      type: Array,
      default: () => []
    },
    defaultTab: String
  },
  data () {
    return {
      inset: true
    }
  },
  mounted() {
    window.addEventListener("resize", this.onResize);
    this.onResize();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  computed: {
    editorKey () {
      // Recreate the editor when the edited item changes (e.g. cloned new event -> saved event),
      // but keep it when only the tab query changes.
      return [this.$route.name, this.$route.params.id, this.$route.query.clone_id].join("|");
    },
    fullscreen () {
      return this.$root.bottomSheetFullscreen;
    },
    visible: {
      get () {
        return (this.router && this.$root.bottomSheet) || (!this.router && this.value);
      },
      set (val) {
        if(this.router) this.$root.bottomSheet = val;
        if(!this.router) this.$emit("input", val);
      }
    },
    BottomSheetClasses() {
      return {
        "ks-bottom-sheet-fullscreen" : !!this.fullscreen
      }
    }
  },
  methods: {
    onResize() {
      if(window.innerWidth < 1440) {
        this.inset = false;
      } else {
        this.inset = true;
      }
    }
  }
}
</script>

<style>
.ks-bottom-sheet {
  height: 70vh;
  overflow: hidden;
}
.ks-bottom-sheet-fullscreen {
  height: 100vh;
}
</style>
